import { render, staticRenderFns } from "./marketingTargetDetail.vue?vue&type=template&id=654b6bfe&scoped=true"
import script from "./marketingTargetDetail.vue?vue&type=script&lang=js"
export * from "./marketingTargetDetail.vue?vue&type=script&lang=js"
import style0 from "./marketingTargetDetail.vue?vue&type=style&index=0&id=654b6bfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654b6bfe",
  null
  
)

export default component.exports